import { ReactComponent as BindBoxIcon } from '@/assets/images/svg/bindbox.svg';
import { ReactComponent as MyLazbubuIcon } from '@/assets/images/svg/person.svg';
import { isBSCNetwork, isLazaiNetwork } from '@/constant';
import BlindBox from '@/pages/BlindBox';
import Gift from '@/pages/Gift';
import Home from '@/pages/Home';
import LazbubuDailyAirdrop from '@/pages/LazbubuDailyAirdrop';
import MyLazbubu from '@/pages/MyLazbubu';
import Lazbubu from '@/pages/Play';
import PointsPage from '@/pages/Points';
import Share from '@/pages/Share';
export interface RouteConfig {
    path: string;
    component: React.ComponentType;
    name: string;
    exact?: boolean;
}

export const routes: RouteConfig[] = [
    {
        path: '/',
        component: Home,
        exact: true,
        name: 'Home',
    },
    ...(isLazaiNetwork
        ? [
              {
                  path: '/lazbubu/boxdrop',
                  exact: true,
                  component: LazbubuDailyAirdrop,
                  name: 'LazbubuBoxDrop',
              },
          ]
        : []),
    {
        path: '/my',
        component: MyLazbubu,
        exact: true,
        name: 'MyLazbubu',
    },

    {
        path: '/blind-box',

        component: BlindBox,
        name: 'BlindBox',
        exact: true,
    },

    {
        path: '/lazbubu/:id',
        component: Lazbubu,
        name: 'Lazbubu',
    },
    {
        path: '/share/:id',
        component: Share,
        name: 'Share',
    },
    {
        path: '/gift',
        component: Gift,
        name: 'Gift',
    },

    ...(isBSCNetwork
        ? [
              {
                  path: '/points',
                  component: PointsPage,
                  name: 'Points',
                  exact: true,
              },
          ]
        : []),
];

export const NavConfig = [
    {
        label: 'My Lazbubu',
        icon: MyLazbubuIcon,
        path: '/my',
    },
    {
        label: 'Blind box',
        icon: BindBoxIcon,
        path: '/blind-box',
    },
    // {
    //     label: 'Gift',
    //     icon: GiftIcon,
    //     path: '/gift',
    // },
] as const;

console.log(routes);
